<template>
  <div>
    <MessageAndCatering
      ref="messageAndCatering"
      class="mb-6"
      @track="track"
    />

    <Captcha :config="$store.state.captcha" @onTokenResponse="(token) => { $store.commit('setCaptchaToken', token); }" />

    <BaseButton
      v-if="!canFinishEnquiry"
      color="red"
      size="large"
      class="w-full flex items-center justify-center"
      data-test-id="enquiry-form__msg-and-catering-btn"
      @click="submit"
    >
      {{ $store.getters.cta.secondStep }}
      <TagIcon
        :icon="ChevronRightIcon"
        color="mono-white"
        class="ml-2"
      />
    </BaseButton>

    <FinishEnquiryButton
      v-else
      data-test-id="enquiry-form__msg-and-catering-btn"
      @click="submit"
    />

    <BackButton @click="back" />
  </div>
</template>

<script>
import ChevronRightIcon from '@tagvenue/icons/24/bold/arrows/chevron-right.svg';
import ChevronLeftIcon from '@tagvenue/icons/24/line/arrows/chevron-left.svg';
import { markRaw } from 'vue';

import TagIcon from '@/components/TagIcon.vue';
import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';

import BackButton from '../components/buttons/BackButton.vue';
import FinishEnquiryButton from '../components/buttons/FinishEnquiryButton.vue';
import Captcha from '../components/Captcha.vue';
import MessageAndCatering from '../forms/MessageAndCatering.vue';

export default {
  name: 'StepMessageAndCatering',
  emits: ['submit', 'back'],
  components: { Captcha, FinishEnquiryButton, BackButton, TagIcon, BaseButton, MessageAndCatering },

  props: {
    canFinishEnquiry: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      ChevronRightIcon: markRaw(ChevronRightIcon),
      ChevronLeftIcon: markRaw(ChevronLeftIcon),
    };
  },

  methods: {
    submit() {
      this.$store.dispatch('trackGA4Interaction', {
        section: 'message',
        element: this.canFinishEnquiry ? 'send_message_button' : 'finish_enquiry_button',
        value: null,
        interaction: 'click',
      });

      const label = this.canFinishEnquiry ? 'send-message' : 'finish-your-enquiry';
      this.$store.dispatch('trackEnquiryFormNavigation', { label });

      const { isValid } = this.$refs.messageAndCatering.submit();
      if (isValid) {
        this.$emit('submit');
        this.$store.dispatch('trackEnquiry', 'form');
      }
    },

    back() {
      this.$store.dispatch('trackGA4Interaction', {
        section: 'message',
        element: 'back_button',
        interaction: 'click',
      });

      this.$store.dispatch('trackEnquiryFormBackNavigation', {
        label: 'back-from-1', // 1st step in old enquiry form
        errors: this.$refs.messageAndCatering.errors,
        values: this.$refs.messageAndCatering.values,
      });
      this.$emit('back');
    },
    track({ element, interaction, value }) {
      this.$store.dispatch('trackGA4Interaction', {
        section: 'message',
        element,
        interaction,
        value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
